import { CategoryLists } from '@/models/CategoryKey';

export const ModelKey = {
  TheTerraceSoundBar01: 'TheTerraceSoundbar_DeskStationeryD',
};

export default {
  categoryKey: CategoryLists.HomeAudio.list.TheTerraceSoundBar,
  cover: {
    caption: 'LandingPage.TheTerraceSoundbar',
    backgroundImage: require('../../cover_image/cover_deskStationery.jpg'),
    mobileCoverImage: require('../../cover_image/cover_deskStationery.jpg'),
    mainImage: {
      src: require('../../../assets/categories/TheTerraceSoundBar.png'),
      pcSrc: require('../../../assets/categories/TheTerraceSoundBar.png'),
    },
  },
  box: {
    title: 'ProductPage.selectDesign', //i18n
    list: [
      {
        key: ModelKey.TheTerraceSoundBar01,
        image: {
          mobile: require('../../thumbnail/DeskStationaryD.png'),
          pc: require('../../thumbnail/DeskStationaryD.png'),
        },
        title: 'ProductPage.DeskStationary', // i18n
        text: 'D',
        level: 2,
        minutes: 60,
        allowInches: [],
      },
    ],
  },
  dezeenBox: {},
  worldcup:{},
  disney:{},
  ModelKey: ModelKey,
};

export const Boxes = {
  [ModelKey.TheTerraceSoundBar01]: () => import('./deskstationeryD'),
};
